import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const BuildingFilledIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
      {...props}
    >
      <path
        data-color="color-2"
        fill={color}
        d="M23,3h-6V0h-2v3H9C8.447,3,8,3.447,8,4v12h2V5h12v7h2V4C24,3.447,23.553,3,23,3z"
      />
      <path
        fill={color}
        d="M31,14H18c-0.553,0-1,0.447-1,1v15h-2V19c0-0.553-0.447-1-1-1H1c-0.553,0-1,0.447-1,1v12 c0,0.553,0.447,1,1,1h30c0.553,0,1-0.447,1-1V15C32,14.447,31.553,14,31,14z M10,28H5v-2h5V28z M10,24H5v-2h5V24z M27,28h-5v-2h5V28 z M27,24h-5v-2h5V24z M27,20h-5v-2h5V20z"
      />
    </svg>
  );
};
